export const env = {
	new_proc_url:
		"https://pagoswebalv-dev.transnegrd.com/?redirect=https://ayuntamientovega.dev.cloud.processmaker.net/webentry/11/node_7",
	query_proc_url:
		"https://pagoswebalv-dev.transnegrd.com/?redirect=https://lavega.transnegrd.com/urban/query-inner",
}
